import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

interface FieldHelpTooltipProps {
  text: string;
}

export default function FieldHelpTooltip({ text }: FieldHelpTooltipProps) {
  return (
    <Tooltip
      title={text}
      arrow
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={6000}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 360,
            whiteSpace: "pre-line",
          },
        },
      }}
    >
      <IconButton
        type="button"
        size="small"
        aria-label="Show field help"
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
        sx={{
          color: "#6b7280",
          marginLeft: "2px",
          padding: "2px",
          verticalAlign: "middle",
        }}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
